module.exports = __webpack_public_path__ + "img/bg.95288990.png";